import { render, staticRenderFns } from "./MedicalActionChart.vue?vue&type=template&id=5a1dce72&"
import script from "./MedicalActionChart.vue?vue&type=script&lang=js&"
export * from "./MedicalActionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports